import { Box, styled } from '@mui/material';

interface CircleBoxProps {
  circleColor: string;
}

export const CircleBox = styled(Box)<CircleBoxProps>(({ circleColor }) => ({
  width: 32,
  height: 32,
  borderRadius: '50%',
  backgroundColor: circleColor,
  color: 'white',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontWeight: 600,
  fontSize: 16,
  marginBottom: 8
}));
